// Copyright 2025 Sorama B.V.

import { autoinject } from "aurelia-framework";

declare global {
    interface Window {
        hbspt?: {
            forms: {
                create: (options: { region: string; portalId: string; formId: string; target: string }) => void;
            };
        };
    }
}

@autoinject
export class HubSpotForm {
    public formId = "6f45f225-1f61-46e7-a79d-eeb272f4f045";
    public portalId = "139691216";
    public region = "eu1";

    constructor(private readonly element: Element) {}

    public async attached(): Promise<void> {
        await this.loadHubSpotScript();
        this.createForm();
    }

    private loadHubSpotScript(): Promise<void> {
        return new Promise((resolve) => {
            // If HubSpot is already loaded
            if (window.hbspt) {
                resolve();
                return;
            }

            // Check if script is already being loaded
            const existingScript = document.querySelector('script[src*="hsforms.net/forms/embed/v2.js"]');
            if (existingScript) {
                existingScript.addEventListener("load", () => resolve());
                return;
            }

            // Load HubSpot script
            const script = document.createElement("script");
            script.src = `https://js-${this.region}.hsforms.net/forms/embed/v2.js`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();

            document.head.appendChild(script);
        });
    }

    private createForm(): void {
        if (!window.hbspt) return;

        const form = this.element.querySelector(".hubspot-form") as HTMLElement;
        if (!form) return;

        if (!form.id) {
            form.id = "hubspot-form";
        }

        window.hbspt.forms.create({
            region: this.region,
            portalId: this.portalId,
            formId: this.formId,
            target: `#${form.id}`,
        });
    }
}
